// Central SEO configuration. Set the real production domain here once
// (or via REACT_APP_SITE_URL) and every canonical / sitemap / OG url follows.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://elmajdoub.space"
).replace(/\/$/, "");

export const SITE_NAME = "Mounir El Majdoub";
export const JOB_TITLE = "Web Master & Fullstack Developer";
export const SITE_TITLE = `${SITE_NAME} | ${JOB_TITLE}`;

export const DEFAULT_DESCRIPTION =
  "Mounir El Majdoub, web master and fullstack developer based in Casablanca. Portfolio of fast, refined websites and web applications across real estate, corporate, brand and event projects.";

export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const SOCIALS = [
  "https://www.linkedin.com/in/elmajdoubmounir/",
  "https://www.instagram.com/mejdubmunir",
];

const ctx = "https://schema.org";

export const personJsonLd = {
  "@context": ctx,
  "@type": "Person",
  name: SITE_NAME,
  jobTitle: JOB_TITLE,
  url: SITE_URL,
  email: "elmajdoubmounir@gmail.com",
  telephone: "+212777477316",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Casablanca",
    addressCountry: "MA",
  },
  knowsAbout: [
    "Web development",
    "Fullstack development",
    "WordPress",
    "E-commerce",
    "SEO",
    "Digital marketing",
  ],
  sameAs: SOCIALS,
};

export const websiteJsonLd = {
  "@context": ctx,
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  inLanguage: "en",
};

// breadcrumb from a list of { name, path }
export const breadcrumbJsonLd = (items) => ({
  "@context": ctx,
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

// a portfolio project rendered as a CreativeWork pointing at the live site
export const projectJsonLd = (project) => ({
  "@context": ctx,
  "@type": "CreativeWork",
  name: project.name,
  url: project.url,
  about: project.category,
  inLanguage: "en",
  creator: {
    "@type": "Person",
    name: SITE_NAME,
    url: SITE_URL,
  },
});
